<template>
  <Navbar />
  <Header v-bind:title="title" />

  <section class="info-section">
    <router-link class="tab-label" to="/overview">歷年政大概覽</router-link>
    <!-- <router-link class="tab-label" to="/datavisualization">校務資料視覺化</router-link> -->
    <div class="tab-label focus">校務資料運用</div>
    
    <div class="tab-content">
      <h2 class="proj-tab-title">校務資料運用</h2>
      <table class="table table-hover rwd-table">
        <thead>
          <tr>
            <th>申請學期</th>
            <th class="th-title">計畫名稱</th>
            <th>計畫主持人</th>
            <th>資料使用期限</th>
            <th>目前執行狀態</th>
          </tr>
        </thead>
        
        <tbody>
            <tr v-for="item in projs" :key="item.id">
              <td data-th="申請學期" class="td-center">{{ item.semester }}</td>
              <td data-th="計畫名稱">{{ item.title }}</td>
              <td data-th="計畫主持人" class="td-center">{{ item.host }}</td>
              <td data-th="資料使用期限" class="td-center">{{ item.period }}</td>
              <td data-th="目前執行狀態" class="td-center">{{ item.state }}</td>
            </tr>
        </tbody>
      </table>
    </div>
  </section>

  <Footer />
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import TabWrapper from "@/components/TabWrapper.vue";
import Tab from "@/components/Tab.vue";

export default {
  name: "App",
  components: { Navbar, Header, Footer, Tab, TabWrapper },
  data() {
    return {
      title: "校務資訊",
      projs: []
    };
  },

  mounted() {
    fetch('https://oir.nccu.edu.tw/codeigniter/api/dataprojs')
    .then((respond) => respond.json())
    .then((data) => {
        data.forEach(element => {     
            this.projs.push(element);
        });
    })
    .catch((err) => console.log(err.message))
  }
};
</script>

<style src="@/assets/css/tab.css" scoped></style>
<style src="@/assets/css/proj.css" scoped></style>
<style src="@/assets/css/rwd-table.css" scoped></style>
<style src="@/assets/css/table.css" scoped></style>

<style scoped>
.info-section {
    display: grid;
    grid-template-columns: 250px 1fr;
    grid-template-rows: 70px 70px 70px 70px auto;
    width: 90%;
    max-width: 1280px;
    margin: 20px auto;
    padding: 10px 20px;
    background-color: whitesmoke;
}

@media  screen and (max-width: 768px) {
  .info-section {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto 1fr;
    width: 100%;
    padding: 10px 0px
  }

  .focus {
    grid-column: span 1;
  }
}
</style>